"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmStatusChangeWithModal = exports.confirmArchiveWithModal = exports.confirmStatusChangeWithModal = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var PageStateChecklist_1 = require("Common/Modal/PageModals/PageStateChecklist");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classes = (0, BemBuilder_1.default)("page-state-change-confirmation-modal");
var PageStatusChangeConfirmationModal = function (_a) {
    var finalStatus = _a.finalStatus, rest = __rest(_a, ["finalStatus"]);
    var statusDisplayText = (0, Utils_1.pageStatusDisplayText)(finalStatus);
    return (react_1.default.createElement(PageStateChangeConfirmationModal, __assign({ checkboxLabel: "Don't show when setting to ".concat(statusDisplayText, " again"), useHistoryId: finalStatus, checklistComponent: react_1.default.createElement(PageStateChecklist_1.PageStateChecklist, { pageStatus: finalStatus }) }, rest)));
};
var PageStateChangeConfirmationModal = function (_a) {
    var modal = _a.modal, useHistoryDataStore = _a.useHistoryDataStore, illustration = _a.illustration, useHistoryId = _a.useHistoryId, checklistComponent = _a.checklistComponent, checkboxLabel = _a.checkboxLabel, titleText = _a.titleText, explainerText = _a.explainerText, confirmText = _a.confirmText, cancelText = _a.cancelText, onConfirmClick = _a.onConfirmClick, onCancelClick = _a.onCancelClick;
    var _b = __read((0, react_1.useState)(false), 2), shouldHide = _b[0], setShouldHide = _b[1];
    var handleConfirmClick = function () {
        onConfirmClick();
        if (shouldHide) {
            useHistoryDataStore.hidePageStateChangeConfirmationModal(useHistoryId);
        }
        modal.closeAnyModals();
    };
    var handleCancelClick = function () {
        if (onCancelClick) {
            onCancelClick();
        }
        modal.closeAnyModals();
    };
    var handleMouseDownEvent = (0, react_1.useCallback)(function (e) {
        e.nativeEvent.stopImmediatePropagation();
    }, []);
    return (react_1.default.createElement("div", { className: classes(), onMouseDown: handleMouseDownEvent },
        react_1.default.createElement("img", { className: classes("hero-icon"), src: illustration }),
        react_1.default.createElement("div", { className: classes("title") }, titleText),
        react_1.default.createElement("div", { className: classes("explainer") }, explainerText),
        checklistComponent,
        react_1.default.createElement("div", { className: classes("button-container") },
            react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, onClick: handleCancelClick }, cancelText),
            react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, onClick: handleConfirmClick, buttonState: kaleidoscope_1.ButtonState.Idle }, confirmText)),
        react_1.default.createElement(kaleidoscope_1.Checkbox, { item: {
                id: "dontShowAgainCheckbox",
                value: "dontShowAgainCheckbox",
                label: checkboxLabel,
            }, isSelected: shouldHide, onChange: function () { return setShouldHide(!shouldHide); } })));
};
var showStatusConfirmationModal = function (modal, useHistoryDataStore, props) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
                var onConfirmClick, onCancelClick, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            onConfirmClick = function () {
                                resolve(true);
                            };
                            onCancelClick = function () {
                                resolve(false);
                            };
                            return [4, modal.showSimpleModal({
                                    isEscapable: false,
                                    body: (react_1.default.createElement(PageStatusChangeConfirmationModal, __assign({ modal: modal, useHistoryDataStore: useHistoryDataStore, onConfirmClick: onConfirmClick, onCancelClick: onCancelClick, confirmText: "Confirm", cancelText: "Cancel" }, props))),
                                })];
                        case 1:
                            res = _a.sent();
                            resolve(res);
                            return [2];
                    }
                });
            }); })];
    });
}); };
var showChangeToLiveConfirmationModal = function (modal, useHistoryDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, showStatusConfirmationModal(modal, useHistoryDataStore, {
                illustration: "Assets/Images/set-live-confirmation.png",
                finalStatus: Types_1.ProjectStatus.Live,
                titleText: "Set page to live?",
                explainerText: "When a page is live, it will be accessible to anyone you share the public link with, and start tracking their engagement.",
            })];
    });
}); };
var showChangeToDraftConfirmationModal = function (modal, useHistoryDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, showStatusConfirmationModal(modal, useHistoryDataStore, {
                illustration: "Assets/Images/set-draft-confirmation.png",
                finalStatus: Types_1.ProjectStatus.Draft,
                titleText: "Set page to draft?",
                explainerText: "When a page is in draft mode, the page will be editable but no one will be able to access it using the public link.",
            })];
    });
}); };
var showChangeToAcceptedConfirmationModal = function (modal, useHistoryDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, showStatusConfirmationModal(modal, useHistoryDataStore, {
                illustration: "Assets/Images/set-accepted-confirmation.png",
                finalStatus: Types_1.ProjectStatus.Accepted,
                titleText: "Set page to Accepted?",
                explainerText: "When a page is in accepted, the page will be locked and will not be editable. You will still be able to access it using the public link.",
            })];
    });
}); };
var showChangeToDeclinedConfirmationModal = function (modal, useHistoryDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, showStatusConfirmationModal(modal, useHistoryDataStore, {
                illustration: "Assets/Images/set-declined-confirmation.png",
                finalStatus: Types_1.ProjectStatus.Declined,
                titleText: "Set page to Declined?",
                explainerText: "When a page is in declined, the page will be locked and will not be editable. You will not be able to access it using the public link.",
            })];
    });
}); };
var confirmArchiveWithModal = function (modal, useHistoryDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        if (!useHistoryDataStore.shouldShowPageStateChangeConfirmationModal("archived")) {
            return [2, true];
        }
        return [2, new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
                var onConfirmClick, onCancelClick, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            onConfirmClick = function () {
                                resolve(true);
                            };
                            onCancelClick = function () {
                                resolve(false);
                            };
                            return [4, modal.showSimpleModal({
                                    isEscapable: false,
                                    body: (react_1.default.createElement(PageStateChangeConfirmationModal, { modal: modal, useHistoryDataStore: useHistoryDataStore, onConfirmClick: onConfirmClick, onCancelClick: onCancelClick, useHistoryId: "archived", checkboxLabel: "Don't show when archiving again", checklistComponent: react_1.default.createElement(PageStateChecklist_1.ArchiveConfirmationChecklist, null), confirmText: "Confirm", cancelText: "Cancel", illustration: "Assets/Images/move-to-archived-confirmation.png", titleText: "Move page to archived?", explainerText: "When draft and live pages are archived, it will be accessible to anyone you share the public link with, and will lose tracking their reports. Accepted and declined pages are included in the reports if archived within the current period." })),
                                })];
                        case 1:
                            res = _a.sent();
                            resolve(res);
                            return [2];
                    }
                });
            }); })];
    });
}); };
exports.confirmArchiveWithModal = confirmArchiveWithModal;
var CONFIRM_MODAL_MAPPING = Object.freeze((_a = {},
    _a[Types_1.ProjectStatus.Draft] = showChangeToDraftConfirmationModal,
    _a[Types_1.ProjectStatus.Live] = showChangeToLiveConfirmationModal,
    _a[Types_1.ProjectStatus.Accepted] = showChangeToAcceptedConfirmationModal,
    _a[Types_1.ProjectStatus.Declined] = showChangeToDeclinedConfirmationModal,
    _a));
var confirmStatusChangeWithModal = function (status, modal, useHistoryDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        if (!useHistoryDataStore.shouldShowPageStateChangeConfirmationModal(status)) {
            return [2, true];
        }
        return [2, CONFIRM_MODAL_MAPPING[status](modal, useHistoryDataStore)];
    });
}); };
exports.confirmStatusChangeWithModal = confirmStatusChangeWithModal;
var useConfirmStatusChangeWithModal = function () {
    var modal = (0, inversify_react_1.useInjection)("modal");
    var rootDataStore = (0, inversify_react_1.useInjection)("rootDataStore");
    return {
        confirmFn: function (status) {
            return confirmStatusChangeWithModal(status, modal, rootDataStore.userDataStore.useHistoryDataStore);
        },
    };
};
exports.useConfirmStatusChangeWithModal = useConfirmStatusChangeWithModal;
